<!-- 新春游戏过渡页 -->
<template>
</template>

<script>
import request from "@/utils/request";
import { Toast, Dialog } from 'vant'
import { initAgentConfig } from '@/utils/wxCodeAuth'

export default {
    name: 'gameTemp',
    data() {
        return {

        }
    },
    async created() {
        await initAgentConfig();
        //隐藏转发功能
        wx.hideOptionMenu({
            success: function (res) {
                console.log('已隐藏转发');
            },
            fail: function (res) {
                console.log("sdk调用失败");
            }
        });
        this.getGameToken()
    },
    methods: {
        // 换game的token
        getGameToken() {
            request({
                url: "/game/agent/exchangeToken",
                method: "get",
            })
                .then((res) => {
                    window.location.replace(`${window.SITE_CONFIG['gameApiUrl']}?s=${new Date().getTime()}&token=${res.data.token}`)
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
    },
}
</script>

<style scoped lang="less">
</style>
